export default "__VITE_ASSET__DnvLre0l__"